export default {
  singular: 'Contest',
  actions: {
    create: 'create a contest',
    confirmDelete: 'Are you sure you want to delete this contest?',
    delete: 'Delete',
    cancel: 'Cancel'
  },
  empty: {
    title: 'No contest',
    message: 'To create a contest, nothing could be easier, just click on the following link:'
  },
  state: {
    published: 'published',
    testing: 'testing',
    terminated: 'finished'
  },
  plural: 'Contests',
  section: {
    rounds: {
      title: 'Rounds'
    },
    ranks: {
      title: 'Rank',
      button: {
        'load-more': 'See more',
        'download': 'Export ranking'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/translations/en/contest.js